import React from 'react'
import LoadingBall from '../components/loading/LoadingBall';

const LoadingScreen = () => {
  return (
    <div className="text-mainWhite">
      <LoadingBall className="w-full h-screen" />
    </div>
  )
}

export default LoadingScreen